/* eslint-disable camelcase */
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import CryptoJS from 'crypto-js'
import isAuthenticated from '../../routes/isAuthenticated'
import ActionData from '../../types/ActionData'
import Organization from '../../types/Organization'
import Provider from '../../types/Provider'
import Role from '../../types/Role'
import CurrentUser from '../../types/User'
import User from '../../types/UserList'
import CircularProgress from '@material-ui/core/CircularProgress'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Container, Row, Col, Breadcrumb, Button, Card, Tab, Nav, Modal } from 'react-bootstrap'
import UserData from '../../components/UserAccount/UserData'
import UserModal from '../../components/Modals/UserModal'
import AllUsers from '../../components/UserAccount/AllUsers'
import { getUsers, addUser, updateUser, getRoles, validateProviderUser } from '../../redux/actions/userAccount'
import { addUserActivity, updateCurrentUser, unauthUser } from '../../redux/actions/authentication'
import { sendMail } from '../../redux/actions/mail'
import './index.css'

interface RouteParams {
  page: string;
}

interface Props {
  addUserResult: ActionData;
  height: number;
  isAuth: boolean;
  mail: ActionData;
  providers: Array<Provider>;
  providerUserExists: ActionData;
  roles: Array<Role>;
  selectedOrganization: Organization;
  updateUserResult: ActionData;
  user: CurrentUser;
  users: Array<User>;
  usersResult: ActionData;
  width:  number;
  addUser: (data: { email: string; enabled: boolean; firstName: string; lastName: string; provider_id: Array<string>; role_id: number; organization_id: Array<string>; eid: string }, token: string) => void;
  addUserActivity: (data: { eid: string; activity: string; memberId?: number; organizationId?: number; providerId?: number }, token: string ) => void;
  getRoles: (token: string) => void;
  getUsers: (organization_id: number, token: string) => void;
  unauthUser: () => void;
  resetAddUser: () => void;
  sendMail: (data: {emailTo: string; subject: string; type: string}) => void;
  updateUser: (data: {enabled: boolean; first_name: string; last_name: string; role_id: number; user_id: number; provider_id: Array<string>; organization_id: Array<string>; user_organizations: Array<Organization>}, token: string) => void;
  updateCurrentUser: (data: { first_name: string; last_name: string}) => void;
  validateProviderUser: (data: { email: string }, token: string) => void;
}

interface UMStateProvider {
  email: string;
  enabled: boolean;
  firstName: string;
  lastName: string;
  organization_id: Array<string>;
  role_id: number;
  provider_id: Array<string>;
}

interface UMState {
  addedUser: string;
  changingUser: boolean;
  duplicateEmail: boolean;
  emailError: boolean;
  filterUsers: string;
  key: string;
  modalType: string;
  provider: UMStateProvider;
  selectedProvider: {
    provider: any;
    role: any;
    organization: any;
  };
  selectedUserId: number;
  sendingMail: boolean;
  showModal: boolean;
  show: boolean;
  sortUsers: string;
  selectedUser?: User;
}

const generateRoleList = (
  roles: Array<Role>
) => {
  return roles.map((role) => {return({value: role.role_id, label: role.description})})
}

const generateProviderList = (
  providers: Array<Provider>,
  listType: number
) => {
  let providerList: any = []
  
  if(listType===1)
    providerList = [{value: '0', label: 'ALL PROVIDERS'}]
	
  providers.forEach((provider) => {providerList.push({value: provider.provider_id+'', label: provider.provider_name})})
   
  return providerList
}

const generateOrganizationList = (
  organizationData: Array<Organization>
) => {
  let organizationList: any = []
	
  if(organizationData !== null && organizationData !== undefined){
    organizationData.forEach((organization) => {organizationList.push({value: organization.organization_id+'', label: organization.organization_name})})
  }
   
  return organizationList
}

class UserAccount extends Component<Props & RouteComponentProps<RouteParams>, UMState> {
  state = {
    filterUsers: '',
    sortUsers: 'a-z',
    showModal: false,
    changingUser: false,
    addedUser: '',
    selectedUserId: -1,
    key: 'profile',
    modalType: '',
    selectedUser: undefined,
    sendingMail: false,
    show: false,
		
    //Selected provider admin user
    duplicateEmail: false,
    emailError: false,
    provider: {
      email: '',
      enabled: true,
      firstName: '',
      lastName: '',
      organization_id: [],
      role_id: -1,
      provider_id: []
    },
    selectedProvider: {
      provider: [],
      role: { value: '', label: ''},
      organization: []
    }
  }
	
  componentDidMount(){
    const { match, user, selectedOrganization, addUserActivity, getUsers, getRoles } = this.props
    const emailKey = 'lakelandproviderportalinsertuserencryption'
    const email = user.isLakeland ? { eid: CryptoJS.AES.encrypt(user.email, emailKey).toString() } : JSON.parse(localStorage.getItem('p_sid')|| '{}')
		
    if (user!==undefined && selectedOrganization.organization_id!==-1 ){
      if (user.role_id===5) {
        let token
        if ( localStorage.getItem('token')!== null && localStorage.getItem('token')!=='undefined' ) {
          token = JSON.parse(localStorage.getItem('token')|| '')
        }

        getUsers(selectedOrganization.organization_id, token)
        getRoles(token)

        if ( match.params.page === 'all' ) {
          this.setState({key:'allUsers'})

          addUserActivity({
            eid: email.eid,
            activity: 'View Account / All Users'
          }, token)
        }
        else {
          this.setState({key:'profile'})

          if ( match.params.page !== 'add' ) {
            addUserActivity({
              eid: email.eid,
              activity: 'View Account / Profile'
            }, token)
          }
        }
				
        if (match.params.page==='add') {
          this.setState({showModal:true, modalType: 'add'})

          addUserActivity({
            eid: email.eid,
            activity: 'View Account / Add User'
          }, token)
        }
        else {
          this.setState({showModal:false, modalType: ''})
        }
      }
      else if (user.role_id===4) {
        let token
        if(localStorage.getItem('token')!== null && localStorage.getItem('token')!=='undefined')
          token = JSON.parse(localStorage.getItem('token')|| '')
					
        getRoles(token)

        if ( match.params.page==='all' ) {
          addUserActivity({
            eid: email.eid,
            activity: 'View Account / All Users'
          }, token)
        }
        else if (match.params.page==='add') {
          addUserActivity({
            eid: email.eid,
            activity: 'View Account / Add User'
          }, token)
        } else {
          addUserActivity({
            eid: email.eid,
            activity: 'View Account / Profile'
          }, token)
        }
      }
    }
  }
  
  componentDidUpdate(prevProps: Props&RouteComponentProps<RouteParams>){
    const { isAuth, match, providerUserExists, selectedOrganization, user, addUserResult, updateUserResult, addUser, addUserActivity, getUsers, getRoles, sendMail, updateCurrentUser } = this.props
    const emailKey = 'lakelandproviderportalinsertuserencryption'
    const email = user.isLakeland ? { eid: CryptoJS.AES.encrypt(user.email, emailKey).toString() } : JSON.parse(localStorage.getItem('p_sid')|| '{}')

    if (prevProps.selectedOrganization !== selectedOrganization && selectedOrganization.organization_id !== -1) {
      if ( isAuth===true ) {
        if ( user.role_id===5 ) {
          let token
          if(localStorage.getItem('token')!== null)
            token = JSON.parse(localStorage.getItem('token')|| '')

          getUsers(selectedOrganization.organization_id, token)
          getRoles(token)

          if(match.params.page==='all')
            this.setState({key:'allUsers'})
          else
            this.setState({key:'profile'})
					
          if(match.params.page==='add')
            this.setState({showModal:true, modalType: 'add'})
          else
            this.setState({showModal:false, modalType: ''})
        }
        else if(user.role_id===4) {
          let token
          if(localStorage.getItem('token')!== null)
            token = JSON.parse(localStorage.getItem('token')|| '')

          getRoles(token)
        }
      }
    }
	
    if ( prevProps.addUserResult.loading !== addUserResult.loading ) {
      if ( addUserResult.success && !addUserResult.error ) {
        let data = {
          emailTo: addUserResult.data.email,
          subject: 'Activate account',
          type: 'activate'
        }
        sendMail(data)
				
        this.setState({
          selectedUserId: addUserResult.data.user_id,
          selectedUser: {
            email: addUserResult.data.email,
            enabled: addUserResult.data.enabled,
            first_name: addUserResult.data.first_name,
            last_name: addUserResult.data.last_name,
            organization_data: addUserResult.data.organization_data,
            organization_id: addUserResult.data.organization_id,
            organization_name: addUserResult.data.organization_name,
            provider_data: addUserResult.data.provider_data,
            role: addUserResult.data.role,
            role_id: addUserResult.data.role_id,
            status: addUserResult.data.status,
            user_id: addUserResult.data.user_id
          }
        })
      }
    }
	
    if ( prevProps.updateUserResult.loading !== updateUserResult.loading ) {
      if ( updateUserResult.success && !updateUserResult.error ) {
        if ( this.state.selectedUserId===user.user_id ) {
          updateCurrentUser({first_name: updateUserResult.data.first_name, last_name: updateUserResult.data.last_name})
        }
      }
    }
	
    if (prevProps.match.params.page !== match.params.page) {
      const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token')|| '') : ''
      if ( user.role_id === 5 ) {
        if( match.params.page === 'all') {
          this.setState({ key: 'allUsers' })

          addUserActivity({
            eid: email.eid,
            activity: 'View Account / All Users'
          }, token)
        }
        else {
          this.setState({ key: 'profile' })

          if ( match.params.page !== 'add' ) {
            addUserActivity({
              eid: email.eid,
              activity: 'View Account / Profile'
            }, token)
          }
        }
			
        if ( match.params.page === 'add' ) {
          this.setState({showModal:true, modalType: 'add'})

          addUserActivity({
            eid: email.eid,
            activity: 'View Account / Add User'
          }, token)
        }
        else {
          this.setState({showModal:false, modalType: ''})
        }
      } else {
        if ( match.params.page==='all' ) {
          addUserActivity({
            eid: email.eid,
            activity: 'View Account / All Users'
          }, token)
        }
        else if (match.params.page==='add') {
          addUserActivity({
            eid: email.eid,
            activity: 'View Account / Add User'
          }, token)
        } else {
          addUserActivity({
            eid: email.eid,
            activity: 'View Account / Profile'
          }, token)
        }
      }
    }

    if(prevProps.providerUserExists.loading !== providerUserExists.loading){
      if(providerUserExists.success && !providerUserExists.error){
        if(providerUserExists.data.length === 0){
          const { provider, modalType } = this.state
          let token
          if(localStorage.getItem('token')!== null)
            token = JSON.parse(localStorage.getItem('token')|| '')

          if(modalType==='add'){
            let data: UMStateProvider = provider

            if(data.role_id === 4){
              data.organization_id = [selectedOrganization.organization_id+'']
            }
            else{
              data.provider_id = []
            }
            addUser({...provider, eid: email.eid }, token)
            this.setState({changingUser: true, addedUser: this.state.provider.firstName+' '+this.state.provider.lastName})
          }
        }
        else{
          this.setState({duplicateEmail: true})
        }
      }
    }
  }

  handleLogout = ()  => {
    const { history, user, addUserActivity, unauthUser } = this.props
    const emailKey = 'lakelandproviderportalinsertuserencryption'
    const email = user.isLakeland ? { eid: CryptoJS.AES.encrypt(user.email, emailKey).toString() } : JSON.parse(localStorage.getItem('p_sid')|| '{}')
    const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token')|| '') : ''

    unauthUser()
    history.push('/login')

    addUserActivity({
      eid: email.eid,
      activity: 'Logout'
    }, token)
  }
  
  handleFilter = (event: any)  => {
    this.setState({filterUsers: event.target.value})
  }

  handleSort = (selected: any) => {
    this.setState({sortUsers: selected.value})
  }
  
  openUserModal = (type: string, event: any, selectedUser?: User) => {
    const { user,providers,roles, addUserActivity } = this.props
    const emailKey = 'lakelandproviderportalinsertuserencryption'
    const email = user.isLakeland ? { eid: CryptoJS.AES.encrypt(user.email, emailKey).toString() } : JSON.parse(localStorage.getItem('p_sid')|| '{}')
    const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token')|| '') : ''
		
    let selectedRoleData = selectedUser!==undefined?generateRoleList(roles).find((role: any)=>role.label===selectedUser.role):{value:'', label:''}
    let providerIdData: Array<string> = []
    let selectedProviderData: any = []
    if(selectedUser!==undefined){
      selectedUser.provider_data.forEach((provider)=>{
        providerIdData.push(provider.provider_id+'')
        selectedProviderData.push(generateProviderList(providers, 0).find((providerList: any)=>providerList.label===provider.provider_name))
      })
    }
    let organizationIdData: Array<string> = []
    let selectedOrganizationData: any = []
    if(selectedUser!==undefined){
      selectedUser.organization_data.forEach((organization)=>{
        let foundSelectedOrganization = generateOrganizationList(user.organization_data).find((organizationList: any)=>{
          if (organizationList.label===organization.organization_name)
            organizationIdData.push(organization.organization_id+'')
          return organizationList.label===organization.organization_name
        })

        if(foundSelectedOrganization !== undefined)
          selectedOrganizationData.push(foundSelectedOrganization)
      })
    }

    this.setState({
      addedUser: type==='add'?'':selectedUser!==undefined?selectedUser.first_name+' '+selectedUser.last_name:'',
      showModal: true,
      modalType: type,
      selectedUser: selectedUser,
      selectedUserId: type==='add'?-1:selectedUser!==undefined?selectedUser.user_id:0
    })
	
    if(type==='edit'){
      this.setState({
        provider: {
          ...this.state.provider,
          enabled: selectedUser!==undefined?selectedUser.enabled:true,
          email: selectedUser!==undefined?selectedUser.email:'',
          firstName: selectedUser!==undefined?selectedUser.first_name:'',
          lastName: selectedUser!==undefined?selectedUser.last_name:'',
          role_id: selectedRoleData!==undefined? selectedRoleData.value as number :-1,
          provider_id: providerIdData,
          organization_id: organizationIdData
        },
        selectedProvider: {
          ...this.state.selectedProvider,
          role: selectedRoleData,
          provider: selectedProviderData,
          organization: selectedOrganizationData
        },
        selectedUserId: selectedUser!==undefined?selectedUser.user_id:-1
      })
    }

    addUserActivity({
      eid: email.eid,
      activity: 'View Account / Add User'
    }, token)
  }

  closeUserModal = () => {
    this.setState({
      showModal: false,
      changingUser: false,
      duplicateEmail: false,
      addedUser: '',
      selectedUserId: -1,
      modalType: '',
      provider: {
        email: '',
        enabled: true,
        firstName: '',
        lastName: '',
        organization_id: [],
        role_id: -1,
        provider_id: []
      },
      selectedProvider: {
        provider: [],
        role: { value: '', label: ''},
        organization: []
      }
    })
  }
  
  handleOnChangeUser = (selected: any) => {
    this.setState({selectedUserId: selected.value, addedUser: selected.label})
  }
  
  handleOnChangeRole = (selected: any) => {
    this.setState({
      provider: {
        ...this.state.provider,
        role_id: selected.value
      }, 
      selectedProvider: {
        ...this.state.selectedProvider,
        role: selected
      }
    })
  }
  
  handleOnChangeProvider = (selected: any) => {
    let providerIds: Array<string>=[]
    if(selected !== null)
      selected.forEach((value: any)=>{
        providerIds.push(value.value)
      })
    this.setState({
      provider: {
        ...this.state.provider,
        provider_id: providerIds
      }, 
      selectedProvider: {
        ...this.state.selectedProvider,
        provider: selected !== null?selected:[],
        organization: []
	  }})
  }
  
  handleOnChangeOrganization = (selected: any) => {
    let organizationIds: Array<string>=[]
    if(selected !== null)
      selected.forEach((value: any)=>{
        organizationIds.push(value.value)
      })
    this.setState({
      provider: {
        ...this.state.provider,
        organization_id: organizationIds
      }, 
      selectedProvider: {
        ...this.state.selectedProvider,
        organization: selected !== null?selected:[],
        provider: []
	  }})
  }
  
  handleOnChangeEnabled = () => {
    this.setState({
      provider: {
        ...this.state.provider,
        enabled: !this.state.provider.enabled
      }
    })
  }
  
  handleAddUser = () => {
    const { provider, modalType, selectedUserId } = this.state
    const { selectedOrganization, user, updateUser, validateProviderUser } = this.props
    const emailKey = 'lakelandproviderportalinsertuserencryption'
    const email = user.isLakeland ? { eid: CryptoJS.AES.encrypt(user.email, emailKey).toString() } : JSON.parse(localStorage.getItem('p_sid')|| '{}')
    let token
    if(localStorage.getItem('token')!== null)
      token = JSON.parse(localStorage.getItem('token')|| '')

    if(modalType==='add'){
      validateProviderUser({email: provider.email}, token)
    }
    else{
      let data: UMStateProvider = provider
      data.organization_id = [selectedOrganization.organization_id+'']
			
      if (data.role_id === 5) {
        data.provider_id = []
      }

      let updateData = {
        enabled: data.enabled, 
        first_name: data.firstName, 
        last_name: data.lastName,
        role_id: data.role_id,
        user_id: selectedUserId,
        provider_id: data.provider_id,
        organization_id: data.organization_id,
        user_organizations: user.organization_data,
        eid: email.eid
      }
      updateUser(updateData, token)
      this.setState({changingUser: true, addedUser: this.state.provider.firstName+' '+this.state.provider.lastName})
    }
  }
  
  handleEditUser = () => {
    this.setState({modalType: 'edit', changingUser: false})
  }
  
  handleOnChangeProviderFields = (event: any, name: string)  => {
    this.setState({
      provider:{
        ...this.state.provider,
        [name]: event.target.value
      }
    }, () => {
      var pattern = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/ // eslint-disable-line no-useless-escape
				
      if(name==='email'){
        let valid = pattern.test(this.state.provider.email)
        let emailError = false

        if(this.state.provider.email!==''&&!valid)
          emailError=true

        this.setState({emailError})
      }
    }
    )
  }
	
  handleOnChangeTab = (key: any) => {
    this.setState({ key })
    if(key === 'allUsers')
      this.props.history.push('/user/all')
    else if(key === 'profile')
      this.props.history.push('/user')
  }
	
  handleSendEmail = (user: User) =>{
    let data = {
      emailTo: user.email,
      subject: 'Activate account',
      type: 'activate'
    }

    this.props.sendMail(data)
    this.setState({
      show: true,
      sendingMail: true
    })
  }

  handleClose = () => {
    this.setState({
      show: false,
      sendingMail: false
    })
  }

  render() {
    const {addUserResult, height, providers, roles, selectedOrganization, user, users, usersResult, updateUserResult, width} = this.props
    const {addedUser, changingUser, duplicateEmail, emailError, filterUsers, key, modalType, provider, selectedProvider, selectedUser, showModal, sortUsers} = this.state
		
    const providerOptions = generateProviderList(providers, 0)
    const organizationOptions = generateOrganizationList(user.organization_data)
		
    let cardStyleWithoutHeight = {border:'none', width:width} 
    let cardStyleWithHeight = {border:'none', width:width, height:height-134}
    let enabled = user!==undefined? user.enabled?'Enabled':'Disabled' : 'Disabled'
    let roleOptions = generateRoleList(roles)
		
    let addUserButton
    let allUsersNavItem
    let allUsersTabPane
    if(user.role_id===5){
      addUserButton = (
        <Button className="userAccountAddUserButton" onClick={(e: any) => this.openUserModal('add', e)}>
          <FontAwesomeIcon icon={['fas', 'plus-circle']}/> Add a User
        </Button>)
		
      allUsersNavItem = (
        <Nav.Item className='user-account-nav-item'>
          <Nav.Link eventKey="allUsers"><b>All Users</b></Nav.Link>
        </Nav.Item>
      )
		
      allUsersTabPane = (
        <Tab.Pane id="user-account-tab-pane-all-users" eventKey="allUsers">
          <AllUsers 
            filterUsers={filterUsers}
            height={height}
            sortUsers={sortUsers}
            users={users}
            usersResult={usersResult}
            onChangeFilter={this.handleFilter}
            onChangeSort={this.handleSort}
            onOpenUserModal={(type: string, e: any, user?: User) => this.openUserModal(type, e, user)}
            onSendEmail={(e: any, user: User) => {this.handleSendEmail(user)}}
          />
        </Tab.Pane>
      )
    }

    let orgProvFieldValidation = false
    if(selectedProvider!== undefined){
      if(parseInt(selectedProvider.role.value)===4){
        if(provider.provider_id.length===0){
          orgProvFieldValidation = true
        }
      }
    }
	
    let loadingIcon = <CircularProgress size={70} />
    let modalText = 'Saving data'
		
    if(this.props.mail.error!== false){
      loadingIcon = <FontAwesomeIcon icon={['fas', 'exclamation-circle']} color="#cb6767" className="modal-success-icon" />
      modalText = this.props.mail.error!==undefined?`The user could not be saved. ${this.props.mail.error.response.body.response}`:''
    }

    return(
      <Container 
        style={{
          paddingTop:20, 
          backgroundColor: '#f5f5f5', 
          width:width, 
          height:height-20, 
          maxWidth:width, 
          overflow:'auto'
        }}>
        <Row>
          <Col lg={12} md={12} sm={12} xs={12}>
            <Row>
              <div className="userAccountHeader" style={{width:width}}>
                <div className="userAccountHeaderText">
                  <div className="userAccountIcon">
                    <FontAwesomeIcon icon={['fas', 'user-circle']} size="3x" />
                  </div>
                  <div>
                    <h4>{user.first_name} {user.last_name}</h4>
                    <Breadcrumb>
                      <Breadcrumb.Item active className="userAccountBreadcrumb">User Role: <b>{user.role}</b></Breadcrumb.Item>
                      <Breadcrumb.Item active className="userAccountBreadcrumb">Access Group: <b>{selectedOrganization.organization_name}</b></Breadcrumb.Item>
                      <Breadcrumb.Item active className="userAccountBreadcrumb">Status: <b>{enabled}</b></Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </div>
                <div className="userAccountButton">
                  {addUserButton}
                  <Button variant="light" onClick={this.handleLogout} id="user-account-btn">
										Logout <FontAwesomeIcon icon={['fas', 'sign-out-alt']}/>
                  </Button>
                </div>
              </div>
            </Row>
            <Row>
              <Tab.Container id="user-account-tab" activeKey={key} onSelect={this.handleOnChangeTab}>
                <Card style={height<610&&key==='profile'?cardStyleWithoutHeight:cardStyleWithHeight}>
                  <Card.Header>
                    <Nav variant="tabs">
                      <Nav.Item className='user-account-nav-item'>
                        <Nav.Link eventKey="profile"><b>My Profile</b></Nav.Link>
                      </Nav.Item>
                      {allUsersNavItem}
                    </Nav>
                  </Card.Header>
                  <Card.Body>
                    <Tab.Content>
                      <Tab.Pane id="user-account-tab-pane-profile" eventKey="profile">
                        <div>
                          <Card className="userAccountCard">
                            <Card.Body className="userAccountCardBody">
                              <UserData
                                duplicateEmail={false}
                                emailError={false}
                                emailProvider={user !== undefined ? user.email || '' : ''}
                                firstNameProvider={user !== undefined ? user.first_name || '' : ''}
                                lastNameProvider={user !== undefined ? user.last_name || '' : ''}
                                organizationOptions={organizationOptions}
                                providerOptions={providerOptions}
                                roleOptions={roleOptions}
                                isLoggedUser={true}
                                selectedEnabledData={user !== undefined ? user.enabled===true : false}
                                selectedRole={user.role!==undefined?roleOptions.find((role: any)=>role.label===user.role):{value:'', label:''}}
                                selectedOrganization={user!==undefined&&user.organization_data!==undefined? user.organization_data.map((organization)=>organizationOptions.find((organizationList: any)=>organizationList.label===organization.organization_name)): []}
                                selectedProvider={user!==undefined&&user.provider_data!==undefined? user.provider_data.map((provider)=>generateProviderList(providers, 0).find((providerList: any)=>providerList.label===provider.provider_name)): []}
                                type={modalType}
                                user={user}
                                viewOnly={true}
                                width={width}
                                onChangeEnabledData={this.handleOnChangeEnabled}
                                onChangeOrganizationData={this.handleOnChangeOrganization}
                                onChangeProviderData={this.handleOnChangeProvider}
                                onChangeProviderFields={(e: any, name: string)=>{this.handleOnChangeProviderFields(e, name)}}
                                onChangeRoleData={this.handleOnChangeRole}
                              />
                            </Card.Body>
                          </Card>
                        </div>
                      </Tab.Pane>
                      {allUsersTabPane}
                    </Tab.Content>
                  </Card.Body>
                </Card>
              </Tab.Container>
            </Row>
          </Col>
        </Row>
        <UserModal
          addedUser={addedUser}
          addUser={addUserResult}
          changingUser={changingUser}
          duplicateEmail={duplicateEmail}
          emailError={emailError}
          emailProvider={provider.email}
          firstNameProvider={provider.firstName}
          lastNameProvider={provider.lastName}
          disableAddButton={provider.email===''||provider.firstName===''||provider.lastName===''||provider.role_id===-1||emailError||orgProvFieldValidation}
          modalType={modalType}
          organizationOptions={organizationOptions}
          providerOptions={providerOptions}
          roleOptions={roleOptions}
          selectedEnabledData={provider.enabled}
          selectedRole={selectedProvider.role}
          selectedOrganization={selectedProvider.organization}
          selectedProvider={selectedProvider.provider}
          selectedUser={selectedUser}
          show={showModal}
          updateUser={updateUserResult}
          user={user}
          width={width}
          onChangeEnabledData={this.handleOnChangeEnabled}
          onChangeOrganizationData={this.handleOnChangeOrganization}
          onChangeProviderData={this.handleOnChangeProvider}
          onChangeProviderFields={(e: any, name: string)=>{this.handleOnChangeProviderFields(e, name)}}
          onChangeRoleData={this.handleOnChangeRole}
          onClickAdd={this.handleAddUser}
          onClickEdit={this.handleEditUser}
          onClose={this.closeUserModal}
        />
        <Modal size='xl' show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Activation Mail</Modal.Title>
          </Modal.Header>
          <Modal.Body
          >
            {
              this.state.sendingMail ? ( 
                this.props.mail.loading || this.props.mail.error!== false  ? (
                  <div className="modal-loading-container">
                    {loadingIcon}
                    <span className="modal-loading-text">{modalText}</span>
                  </div>
                ) : this.props.mail.success ? (
                  <div>
                    <div className="modal-success-container">
                      <FontAwesomeIcon icon={['far', 'check-circle']} color="#75b465" className="modal-success-icon" />
                      <span className="modal-success-text">Mail has been sent.</span>
                    </div>
                  </div>
                ) : (
                  <div></div>
                )
              ) : (<div></div>)
            }
          </Modal.Body>
        </Modal>
      </Container>
    )
  }
}

const mapStateToProps = (state: any) => ({
  addUserResult: state.userAccount.addUser,
  isAuth: state.authentication.isAuth,
  mail: state.mail,
  providers: state.userAccount.providers.data,
  providerUserExists: state.userAccount.providerUserExists,
  roles: state.userAccount.roles.data,
  selectedOrganization: state.authentication.selectedOrganization,
  updateUserResult: state.userAccount.updateUser,
  user: state.authentication.user.data,
  users: state.userAccount.users.data,
  usersResult: state.userAccount.users
})

const mapDispatchToProps = (dispatch: any) => ({
  addUser: (data: { email: string; enabled: boolean; firstName: string; lastName: string; provider_id: Array<string>; role_id: number; organization_id: Array<string>; eid: string }, token: string) => dispatch(addUser(data, token)),
  addUserActivity: (data: { eid: string; activity: string; memberId?: number; organizationId?: number; providerId?: number }, token: string ) => dispatch(addUserActivity(data, token)),
  unauthUser: () => dispatch(unauthUser()),
  getRoles: (token: string) => dispatch(getRoles(token)),
  getUsers: (organization_id: number, token: string) => dispatch(getUsers(organization_id, token)),
  sendMail: (data: {emailTo: string; subject: string; type: string}) => dispatch(sendMail(data)),
  updateUser:  (data: {enabled: boolean; first_name: string; last_name: string; role_id: number; user_id: number; provider_id: Array<string>; organization_id: Array<string>; user_organizations: Array<Organization>}, token: string) => dispatch(updateUser(data, token)),
  updateCurrentUser: (data: { first_name: string; last_name: string}) => dispatch(updateCurrentUser(data)),
  validateProviderUser: (data: { email: string }, token: string) => dispatch(validateProviderUser(data, token))
})

export default isAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(UserAccount)
)